module.exports = __webpack_public_path__ + "img/camp06_actived.bc84cbd5.png";